import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { logout } from '../../redux/auth/authSlice';

// The axios response interceptor (helpers/api/apiCore) redirects on 401,
// this only keeps the store consistent for queries rejected with 401.
export const unauthenticatedMiddleware: Middleware =
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        if (
            isRejectedWithValue(action) &&
            action.payload?.status === 401 &&
            !(getState() as any).auth?.hasUnacceptedPrivacyStatements
        ) {
            dispatch(logout());
        }

        return next(action);
    };
